import { MutationTree } from "vuex";
import { AuthenticationState, CurrentUser, UserResourceClaims, JwtConfigs, UserAutoSettings } from "./types";
import { bus } from "@/bus";
import { SEPARATE_SPA } from "@/app.config";

export const mutations: MutationTree<AuthenticationState> = {
    authSuccess(state, data) {
        state.token = data.token;
        state.tokenValidTo = new Date(Date.now() + data.jwtConfigs.jwtExpireSeconds * 1000 + data.jwtConfigs.jwtInvalidSeconds * 1000);
        state.currentUser = data.currentUser;
        state.jwtConfigs = data.jwtConfigs;
        localStorage.setItem("culture", data.currentUser.cultureCode);
        if (!data.currentUser.isImpersonated) bus.$emit("consentLayout", data.hasConsented);
        if (SEPARATE_SPA) {
            // We set userAuthCookie in SPA only for development mode when the SPA serving is separated from the backend for authentication purpose
            document.cookie = `${encodeURI("userAuthCookie")}=${encodeURI(state.token)}; ${encodeURI("Secure")}; ${encodeURI("SameSite")}=${encodeURI("None")}`;
        }
    },

    updateToken(state, token) {
        state.token = token;
        state.tokenValidTo = new Date(Date.now() + state.jwtConfigs.jwtExpireSeconds * 1000 + state.jwtConfigs.jwtInvalidSeconds * 1000);
        if (SEPARATE_SPA) {
            document.cookie = `${encodeURI("userAuthCookie")}=${encodeURI(state.token)}; ${encodeURI("Secure")}; ${encodeURI("SameSite")}=${encodeURI("None")}`;
        }
    },

    authClear(state) {
        state.jwtConfigs = {} as JwtConfigs;
        state.autoLogout = false;
        state.token = "";
        state.tokenValidTo = null;
        state.currentUser = {} as CurrentUser;
        if (SEPARATE_SPA) {
            document.cookie = `${encodeURI("userAuthCookie")}=""`;
        }
    },

    setAutologout(state, data) {
        state.autoLogout = data;
    },

    updateUserResourceClaims(state, data: Array<UserResourceClaims>) {
        state.currentUser.userResourceClaims = data;
    },

    updateUserAutoSettings(state, data: UserAutoSettings) {
        state.currentUser.userAutoSettings = data;
    },

    updateUserCulture(state, data: string) {
        state.currentUser.cultureCode = data;
        localStorage.setItem("culture", data);
    },

    updateUsername(state, data: CurrentUser) {
        state.currentUser.firstName = data.firstName;
        state.currentUser.lastName = data.lastName;
    }
};
